import { Clapperboard, Gamepad2, Briefcase, GraduationCap, Backpack, Sparkles, Move, Tag, Cable, Frame, Monitor, Wrench, Speaker, Cast, Projector } from "lucide-react";

export const IconMap = {
  Clapperboard, Gamepad2, Briefcase, GraduationCap, Backpack, Sparkles, Move, Tag, Cable,
  Frame, Monitor, Wrench, Speaker, Cast, Projector,
};

export const getIcon = (name) => IconMap[name] || Projector;
